import { useTranslation } from "react-i18next";
import { TimelineBox } from "@app/dashboard/components/inner_layout/Cards/TimelineBox";
import { Accordion } from "@unified-checkout/design-system";
import { ComputerMouseScrollwheel, LinkSimple } from "@unified-checkout/design-system/icons/index";
import { PaymobArrow } from "@unified-checkout/design-system/icons/paymob_logo";
import styles from "./configuration-steps.module.scss";

export const ConfigurationSteps = ({ customUrl }: { customUrl: string }) => {

    const { t } = useTranslation();

    return (
        <Accordion
            header={
                <span className={styles["details-accordion__header"]}>
                    {t('innerLayout.xeroPage.configurationSteps.title')}
                </span>
            }
            isOpen={true}
            type='bordered_box'
            hasDivider
        >
            <TimelineBox
                steps={[
                    {
                        title: {
                            value: t('innerLayout.xeroPage.configurationSteps.step1'),
                        },
                        description: t('innerLayout.xeroPage.configurationSteps.desc1')
                    },
                    {
                        title: {
                            value: t('innerLayout.xeroPage.configurationSteps.step2'),
                        },
                        description: t('innerLayout.xeroPage.configurationSteps.desc2')
                    },
                    {
                        title: {
                            value: t('innerLayout.xeroPage.configurationSteps.step3'),
                        },
                        description: t('innerLayout.xeroPage.configurationSteps.desc3')
                    },
                    {
                        title: {
                            value: t('innerLayout.xeroPage.configurationSteps.step4'),
                        },
                        description: t('innerLayout.xeroPage.configurationSteps.desc4')
                    },
                    {
                        title: {
                            value: t('innerLayout.xeroPage.configurationSteps.step5'),
                        },
                        description: (
                            <div className={styles["step-5-details"]}>
                                <div className={styles["step-5-details__intro"]}>
                                    {t('innerLayout.xeroPage.configurationSteps.desc5')}
                                </div>
                                <div className={styles["step-5-details__row"]}>
                                    <span className={styles["step-5-details__icon"]}>{PaymobArrow}</span>
                                    <span>{t('innerLayout.xeroPage.configurationSteps.accountName')}</span>
                                </div>
                                <div className={styles["step-5-details__row"]}>
                                    <span className={styles["step-5-details__icon"]}>{LinkSimple}</span>
                                    <span>
                                        {customUrl}
                                    </span>
                                </div>
                                <div className={styles["step-5-details__row"]}>
                                    <span className={styles["step-5-details__icon"]}>{ComputerMouseScrollwheel}</span>
                                    <span>{t('innerLayout.xeroPage.configurationSteps.payWithPaymob')}</span>
                                </div>
                            </div>
                        )
                    },
                    {
                        title: {
                            value: t('innerLayout.xeroPage.configurationSteps.step6'),
                        },
                        description: t('innerLayout.xeroPage.configurationSteps.desc6')
                    },
                ]}
            />
        </Accordion>
    );
}

